"use strict";

//var $ = require('jquery');
var ee = require('event-emitter');
var Flux = require('flux');
var Plot = require('./plot/init.js');
var Table = require('./plot/table.js');
var dataAccess = require('./plot/data.js');
var loading = require('./ui/loading.js');
var updatePlot = require('./plot/update.js');
var hue;

function getDispatcher() {
    var myDispatcher = new Flux.Dispatcher();
    //not sure where else to stick globals
    myDispatcher.GRAPH_HEIGHT = 170;
    /**
    * The purpose of this method is to dispatch an update message to plotStore
    *
    * no parameters
    * no returns
    */

    function dispatchUpdate(startTime) {
        return function() {
            //dispatch update message to plotStore
            myDispatcher.dispatch({'status': 'update', 'emit': 'plotEmitter', 'startTime': startTime});
        }
    }

    function dispatchChangeUnits(unitCount) {
        return function() {
            unitCount = (unitCount + 1) % 2
            //dispatch update message to plotStore
            myDispatcher.dispatch({'status': 'changeUnits', 'emit': 'plotEmitter', 'unitCount': unitCount});
        }
    }

    function changeBackgroundColor() {
        // Moves faster between Red, Green, and Blue. This is purely aesthetic to avoid "ugly" colors (I'm looking at
        // you brown-green).
        var skip_jump = 120;
        var acceleration = 2;
        var rate = .2;
        // Exactly rate times faster at skip_jump / 2, and normal speed at skip_jump.
        hue += (acceleration * Math.min(skip_jump - hue % skip_jump, hue % skip_jump) / (skip_jump / 2) + 1) * rate
        // Loops around the color circle.
        if (hue > 360) {
            hue = 0
        }
        // Make the brighter colors more grey to match the darker colors above them.
        document.getElementById('row1').style.backgroundColor = 'hsl(' + hue + ',' + 100 + '%,' + 15 + '%)';
        document.getElementById('row2').style.backgroundColor = 'hsl(' + hue + ',' + 75 + '%,' + 30 + '%)';
        document.getElementById('row3').style.backgroundColor = 'hsl(' + hue + ',' + 50 + '%,' + 45 + '%)';
    }

    //creates checkbox store
    var checkboxEmitter = ee({
        visible: {},
        setPlots: function (plotsInfo) {
            for (var plot_key in plotsInfo) {
                this.visible[plot_key] = true;
            }
        },
        setShowing: function(plotName, visible) {
            if (visible === undefined) {
                this.showing[plotName] = !this.showing[plotName];
            } else {
                this.showing[plotName] = visible;
            }
        },
        getShowing: function(plotName) {
            return this.showing[plotName];
        },
        handleActions: function(action) {
            //only handels if action is for checkbox emitter
            if(action.emit == 'checkboxEmitter')
            {
                this.emit(action.status, action.location);
            }
        }
    });

    //register store with dispatcher
    checkboxEmitter.dispatchToken = myDispatcher.register(checkboxEmitter.handleActions.bind(checkboxEmitter));

    //create plotStore
    // FIXME: Event emitter should be added to a class prototype, not the other way around
    // See https://github.com/medikoo/event-emitter#usage
    // The below works...but only because event-emitter allows it. Should probably stick with advertised features
    var plotEmitter = ee({
        handleActions: function(action) {
            if (action.emit == 'plotEmitter') {
                myDispatcher.waitFor([checkboxEmitter.dispatchToken]);

                if (action.location !== undefined) {
                    this.div = action.location;
                }

                if (action.plotsInfo !== undefined) {
                    this.plotsInfo = action.plotsInfo;
                    this.plotOrder = this.plotsInfo.defaultPlots;
                }
                if (action.plotOrder !== undefined) {
                    this.plotOrder = action.plotOrder;
                }

                if (action.dataCache !== undefined) {
                    this.dataCache = action.dataCache;
                }

                if (action.status == 'get_since_now') {
                    if (this.plotsInfo['isLobbyDisplay']) {
                        action.time = '-6:00:00'
                    }
                    this.emit(
                        action.status,
                        action.time,
                        this.plotsInfo,
                        this.dataCache,
                        this.div);
                }else if (action.status == 'update_table') {
                    this.emit(
                        action.status,
                        action.time,
                        this.plotsInfo,
                        this.div);
                } else if (action.status == 'get_between_dates') {
                    this.emit(
                        action.status,
                        action.start,
                        action.end,
                        action.interval,
                        this.plotsInfo,
                        this.dataCache,
                        this.div);
                } else if (action.status == 'initPlot') {
                    this.emit(
                        action.status,
                        action.location,
                        action.plotOrder ? action.plotOrder : this.plotOrder,
                        this.plotsInfo,
                        this.dataCache);
                } else if (action.status == 'initTable') {
                    this.emit(
                        action.status,
                        action.location,
                        action.plotOrder ? action.plotOrder : this.plotOrder,
                        this.plotsInfo);
                } else if (action.status == 'update') {
                    this.emit(action.status, this.div, this.plotsInfo, this.dataCache, action.startTime);
                } else if (action.status == 'changeUnits') {
                    this.emit(action.status, this.div, this.plotsInfo, this.dataCache, action.unitCount);
                } else {
                    //adds parameter for user information in custom plot
                    // console.debug("Emitting user information message: {action.status} : {action.userInfo}");
                    this.emit(action.status, action.userInfo);
                }
            }
        }
    });


    function stopUpdate(plotsInfo) {
        if(!plotsInfo.progress)
            plotsInfo.progress = {};
        if(plotsInfo.progress.validID){
            var id = plotsInfo.progress.id[0];
            clearInterval(id);
            if (plotsInfo['isLobbyDisplay']) {
                clearInterval(plotsInfo.progress.colorID);
                clearInterval(plotsInfo.progress.lobbyID);
            }
            plotsInfo.progress.validID = false;
        }
    }

    // update every N/2 milliseconds
    const updateInterval = {
        '1m': 30 * 1000,
        '5m': 2.5 * 60 * 1000,
        '1h': 30 * 60 * 1000,
    };


    function startUpdate(startTime, interval, plotsInfo) {
        // stop any previous updates
        if(!plotsInfo.progress)
            plotsInfo.progress = {};
        stopUpdate(plotsInfo);

        // resume update operations
        if (startTime === undefined) {
            startTime = plotsInfo.progress.id[1];
        }
        if (interval === undefined) {
            interval = plotsInfo.progress.id[2];
        }

        // every 30 seconds, rings update alarm
        var intervalID = setInterval(dispatchUpdate(startTime), updateInterval[interval]);
        if (plotsInfo['isLobbyDisplay']) {
            hue = Number(getComputedStyle(document.getElementById("color")).getPropertyValue('--starting-hue'))
            plotsInfo.progress.colorID = setInterval(changeBackgroundColor, 1000)
            plotsInfo.progress.lobbyID = setInterval(dispatchChangeUnits(0), 5000);
        }
        // save alarm id
        plotsInfo.progress.id = [intervalID, startTime, interval];
        plotsInfo.progress.validID = true;
    }

    plotEmitter.on('initTable', function(div, plotOrder, plotsInfo) {
        //initialize checkbox store
        checkboxEmitter.setPlots(plotsInfo);
        Table.initTable(div, plotOrder, plotsInfo);
    });

    plotEmitter.on('update_table',function(time, plotsInfo, div){
        Table.requestTableUpdate(div, plotsInfo);
        setInterval(function(){Table.requestTableUpdate(div,plotsInfo)},updateInterval['1m']);
    });

    plotEmitter.on('initPlot', function(div, plotOrder, plotsInfo, dataCache) {
        //initialize checkbox store
        checkboxEmitter.setPlots(plotsInfo);
        Plot.initPlot(dataCache, div, plotOrder, plotsInfo);
    });

    plotEmitter.on("get_since_now", function(time, plotsInfo, dataCache, div) {
        var interval = dataAccess.requestPlotUpdate(dataCache, div, plotsInfo, time,
            undefined, undefined, undefined, stopUpdate);
        startUpdate(time, interval, plotsInfo);
    });

    plotEmitter.on("get_between_dates",function(start, end, interval, plotsInfo, dataCache, div) {
        stopUpdate(plotsInfo);
        dataAccess.requestPlotUpdate(dataCache, div, plotsInfo, start, end, interval);
    });

    //when store recieves signal, update component
    plotEmitter.on('update', function(div, plotsInfo, dataCache, startTime) {
        dataAccess.requestPlotUpdate(dataCache, div, plotsInfo, startTime, undefined, undefined, true);
    });

    plotEmitter.on('changeUnits', function(div, plotsInfo, dataCache, unitCount) {
        updatePlot.changeUnits(dataCache, document.getElementById(div), plotsInfo, unitCount)
    });

    plotEmitter.on("checking_custom", function()
    {
        //before components were plots. Here, it's the user prompt paragraph
        loading.checkInterval();
    });

    //register plotStore with dispatcher
    plotEmitter.dispatchToken = myDispatcher.register(plotEmitter.handleActions.bind(plotEmitter));

    return myDispatcher;
}

//exports dispatchers and stores
module.exports.getDispatcher = getDispatcher;
